import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { enhancedClosetApi } from '../redux/apis/endpoints/closetApi';

/**
 * Hook that listens for the browser extension's "closet updated" signal
 * and invalidates RTK Query cache so new items appear without refresh.
 *
 * The extension uses chrome.scripting.executeScript(world:'MAIN') to
 * post a message directly into the page's JS context.
 */
const useExtensionSync = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleMessage = (event) => {
      // Only accept messages from same window
      if (event.source !== window) return;
      if (!event.data || event.data.type !== 'SUSU_CLOSET_UPDATED') return;

      console.log('[ExtSync] Extension sync: closet updated, invalidating cache...');

      // Invalidate closet data so RTK Query refetches
      dispatch(enhancedClosetApi.util.invalidateTags(['ClosetClothes', 'Closets']));
    };

    window.addEventListener('message', handleMessage);
    console.log('[ExtSync] Extension sync listener attached');

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [dispatch]);
};

export default useExtensionSync;
